module.exports = __webpack_public_path__ + "static/Hero-Virtual-Care-min-e4d56dd737a0d1bc7a17c45554bfeb15.png";